var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrinkingWinePana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-254"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.16,
    y: 64.96,
    width: 47.62,
    height: 12.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.65,90a1.17,1.17,0,0,1,0-.23c0-.16,0-.36,0-.62,0-.57,0-1.37,0-2.4,0-2.1-.05-5.12-.08-8.93l.15.14L212,78l.24-.23h0V90l-.24-.23,33.94.1,10,.07,2.71,0h.71l.25,0h-.22l-.68,0-2.66,0-10,.06L212,90.2h-.24V77.81h0l.24-.24,47.63.1h.15v.14c0,3.85-.06,6.9-.08,9,0,1,0,1.8,0,2.36,0,.25,0,.45,0,.6A1.39,1.39,0,0,1,259.65,90Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.29,
    y: 44.51,
    width: 103.23,
    height: 170.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.86,
    y: 44.51,
    width: 103.23,
    height: 170.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.26,
    y: 47.98,
    width: 94.44,
    height: 163.94,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584.23,
    y: 69.28,
    width: 58.07,
    height: 121.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.24,147.68c-.14-11.33,10-22.4,21.28-24,5.35-.75,11,.31,16-1.74,8.92-3.66,11.76-15.52,20.75-19l.41,87.7H584.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.21,
    y: 42.93,
    width: 103.23,
    height: 170.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 42.93,
    width: 103.23,
    height: 170.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.17,
    y: 46.4,
    width: 94.44,
    height: 163.94,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.15,
    y: 67.7,
    width: 58.07,
    height: 121.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.15,146.1c-.13-11.33,10.06-22.4,21.28-24,5.36-.75,11,.31,16-1.74,8.93-3.66,11.77-15.52,20.75-19l.41,87.7H96.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.23,
    y: 175.43,
    width: 36.91,
    height: 9.44,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.53,194.81a1.15,1.15,0,0,1,0-.17c0-.13,0-.29,0-.48q0-.67,0-1.86c0-1.63,0-4-.06-6.93l.11.12-36.9.07c.08-.08-.19.18.18-.19h0v9.42l-.19-.18,26.3.08,7.77.06,2.1,0h0l-2.06,0-7.72,0-26.43.08h-.18v-4.82c0-.79,0-1.58,0-2.38v-2.4h0c.38-.36.11-.1.2-.18l36.9.07h.11v.11c0,3,0,5.35-.06,7,0,.79,0,1.4,0,1.84,0,.19,0,.34,0,.46A.72.72,0,0,1,336.53,194.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 337.01,
    width: 47.62,
    height: 12.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,362a2,2,0,0,1,0-.22c0-.16,0-.37,0-.62q0-.87,0-2.4c0-2.1-.05-5.12-.08-8.94l.14.15-47.62.09.24-.23h0V362l-.24-.23,33.94.11,10,.06,2.7,0,.71,0h.25s-.07,0-.22,0h-.68l-2.65,0-10,.07-34.1.1h-.24v-12.4h0l.24-.24,47.62.09h.15v.14c0,3.85-.06,6.9-.08,9,0,1,0,1.8,0,2.37,0,.24,0,.44,0,.6S130.79,362,130.78,362Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.78,
    y: 129.95,
    width: 47.62,
    height: 12.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.27,155a2,2,0,0,1,0-.22c0-.16,0-.37,0-.62,0-.58,0-1.37,0-2.4,0-2.1,0-5.12-.09-8.93l.15.14-47.62.09c.11-.1-.24.24.24-.23h0V149c0,2,0,4,0,6l-.23-.23,33.94.11,10,.06,2.71,0,.71,0h.25s-.07,0-.22,0h-.68l-2.66,0-10,.07-34.1.1h-.24V149c0-1,0-2,0-3.07V142.8h0l.25-.24,47.62.09h.15v.15c0,3.84-.06,6.89-.08,9,0,1,0,1.8,0,2.36,0,.25,0,.44,0,.6S503.28,155,503.27,155Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.51,263.92a1.46,1.46,0,0,1,0-.26c0-.18,0-.42,0-.71,0-.65,0-1.56,0-2.73,0-2.4-.05-5.84-.09-10.19l.17.16-52.15.11.27-.27h0v7q0,3.46,0,6.83l-.26-.26,37.16.11,11,.08,3,0,.77,0,.28,0h-.25l-.74,0-2.91,0-10.91.08-37.34.12h-.26V250h0c.53-.53.14-.15.26-.27l52.15.11h.16V250c0,4.39-.07,7.87-.09,10.29,0,1.15,0,2.05,0,2.69,0,.28,0,.51,0,.69A1.76,1.76,0,0,1,153.51,263.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.58,250a.76.76,0,0,1,0-.26c0-.2,0-.44,0-.74,0-.68,0-1.61,0-2.78,0-2.44-.06-5.87-.1-10.1l.19.19-31.33.08c-.24.23.32-.33.26-.27h0v7.13c0,2.32,0,4.57,0,6.73l-.25-.25,22.41.12,6.53.07,1.76,0,.63,0a3.92,3.92,0,0,1-.57,0l-1.71,0-6.47.07-22.58.12H129V250c0-2.16,0-4.41,0-6.73v-7.13h0c-.06.06.5-.51.27-.27l31.33.08h.19v.19c-.05,4.27-.08,7.75-.11,10.22,0,1.15,0,2.06,0,2.74S160.59,250.05,160.58,250Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.54,236.39s0-.09,0-.26,0-.42,0-.71c0-.65,0-1.56,0-2.73,0-2.4-.05-5.84-.09-10.19l.16.16-52.14.11c.12-.12-.27.27.26-.27h0v13.88l-.26-.27,37.16.12,11,.08,3,0,.78,0a.85.85,0,0,1,.27,0h-.24l-.74,0-2.91,0-10.91.08-37.34.12h-.26v-.26c0-2.24,0-4.52,0-6.83v-7.05h0l.27-.27,52.14.11h.16v.16c0,4.39-.06,7.87-.09,10.29,0,1.15,0,2.05,0,2.69,0,.28,0,.51,0,.69A.89.89,0,0,1,710.54,236.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.61,222.5s0-.09,0-.26,0-.44,0-.74c0-.68,0-1.61-.05-2.78,0-2.44-.06-5.87-.1-10.1l.19.19-31.33.07c-.24.24.32-.32.27-.26h0v3.6c0,1.19,0,2.37,0,3.53,0,2.32,0,4.57,0,6.73l-.25-.25,22.41.12,6.53.07,1.76,0,.63,0a3.75,3.75,0,0,1-.57,0l-1.7,0-6.48.07-22.58.12H686v-.26c0-2.16,0-4.41,0-6.73v-7.13h0l.26-.27,31.33.08h.2v.19c0,4.27-.07,7.75-.1,10.21,0,1.16,0,2.07-.05,2.75A5.59,5.59,0,0,1,717.61,222.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.53,59a1.12,1.12,0,0,1,0-.22c0-.17,0-.37,0-.63,0-.57,0-1.36,0-2.38,0-2.1,0-5.11-.07-8.91l.14.14-45.57.1.23-.24h0V53c0,2,0,4,0,6l-.22-.23,32.47.1,9.59.07,2.59,0h.68l.24,0h-.21l-.65,0-2.55,0-9.53.06-32.63.1h-.23V46.83h0l.23-.23,45.57.09h.14v.14c0,3.84-.06,6.88-.08,9,0,1,0,1.79,0,2.36,0,.24,0,.44,0,.59A1.39,1.39,0,0,1,522.53,59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.71,46.81a.6.6,0,0,1,0-.23c0-.17,0-.38,0-.64,0-.6,0-1.41,0-2.43,0-2.13,0-5.14-.09-8.83l.17.17-27.38.06.23-.23h0v3.14c0,1,0,2.07,0,3.09v5.88l-.22-.22,19.58.11,5.71.06,1.54,0,.55,0-.5,0-1.49,0-5.66.06-19.73.1h-.22V40.93c0-1,0-2,0-3.09V34.7h0s.44-.44.24-.23l27.38.06h.16v.17c0,3.74-.07,6.78-.09,8.93,0,1,0,1.81,0,2.39A7.74,7.74,0,0,1,528.71,46.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671,399.92s-5.49-37.73-5-59.69,0-46.65,0-46.65h2.53s-1.71,43.58.15,69.86,6.77,36.48,6.77,36.48H671",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.35,251.13a6.66,6.66,0,0,0-2.31-3.37c-1.6-1-3.7-.6-5.5,0-7.64,2.71-14.41,17-17.5,24.45l10.15,34.18C690.5,289.43,693.67,267.15,687.35,251.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.45,249.14a2.36,2.36,0,0,1-.15.44l-.49,1.25c-.45,1.08-1.07,2.64-1.82,4.58-1.49,3.88-3.39,9.31-5.1,15.42s-2.86,11.75-3.58,15.85c-.36,2.05-.63,3.71-.8,4.86-.09.54-.16,1-.22,1.32a2.09,2.09,0,0,1-.1.46,1.52,1.52,0,0,1,0-.47c0-.35.08-.79.13-1.33.13-1.16.36-2.83.68-4.89a145.13,145.13,0,0,1,8.7-31.33c.78-1.93,1.45-3.48,1.94-4.53l.57-1.22A1.73,1.73,0,0,1,684.45,249.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.68,314.62c-9.51-5.26-15.12-15.14-15.64-26-.36-7.59,2-15,4.61-22.15a2.86,2.86,0,0,1,1.07-1.61,2.73,2.73,0,0,1,2.59.4c6.91,3.94,11.1,11.44,13.33,19.07A38.46,38.46,0,0,1,675.2,300a26,26,0,0,1-7.52,14.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.68,314.62a1.52,1.52,0,0,1,0-.46c0-.35,0-.78,0-1.31,0-1.14,0-2.79-.14-4.82a130.76,130.76,0,0,0-1.76-15.79c-1.06-6.13-2.34-11.61-3.28-15.57-.47-1.94-.85-3.53-1.13-4.69-.12-.52-.21-1-.29-1.28a1.57,1.57,0,0,1-.07-.46,3.09,3.09,0,0,1,.15.44c.1.33.22.74.37,1.26.31,1.09.75,2.68,1.26,4.66,1,3.94,2.34,9.43,3.4,15.57A116.08,116.08,0,0,1,667.77,308c.05,2,.05,3.69,0,4.83,0,.53,0,1-.06,1.31A2.1,2.1,0,0,1,667.68,314.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.4,372.35c9.36,2,17.07,8.66,26.1,11.86,6,2.13,12.73,2.88,17.5,7.06-1.15-2.89-3.86-4.82-6.5-6.46a115.65,115.65,0,0,0-23.65-11.29c-4.24-1.47-8.85-2.7-13.18-1.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.87,380.69c-11.72-.19-24.06-10.17-35.72-10.77,12.21-3.94,29.69-.72,35.72,10.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.45,352.57c6-2.14,12.49-2.25,18.74-1.27s12.29,3,18.29,5c-.6-4.07-3.89-7.13-7-9.83a48.27,48.27,0,0,0-7.34-5.65,16.28,16.28,0,0,0-8.81-2.48,13.88,13.88,0,0,0-9.72,4.9,16.12,16.12,0,0,0-4.17,9.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.4,339.63c-7.38-6.3-18.55-5.68-28.25-5.46A229.73,229.73,0,0,1,661,361.47C661.36,354.61,654.72,347.59,645.4,339.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.77,330.93a81.63,81.63,0,0,1,11.35-6.59c3.88-1.76,7.5-4.57,11.25-6.61,4.87-2.63,9.08-6.29,13.54-9.55s9.37-6.22,14.83-7.08a29.11,29.11,0,0,0-13.49.78,86.7,86.7,0,0,0-12.7,4.94c-5.76,2.59-11.61,5.25-16.32,9.46s-9,8.36-8.46,14.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.28,380.69l-.37-.16-1-.53c-.88-.47-2.15-1.17-3.75-2-.79-.42-1.66-.85-2.61-1.3s-2-.93-3-1.4a45.51,45.51,0,0,0-7.22-2.51,15.42,15.42,0,0,0-7.52-.19,22.06,22.06,0,0,0-3.18.95A16.34,16.34,0,0,0,673,374.9a16.7,16.7,0,0,0-3.23,2.67c-.68.73-1,1.17-1,1.15a1.33,1.33,0,0,1,.21-.34c.15-.22.39-.53.71-.92a15.28,15.28,0,0,1,3.19-2.81,16.63,16.63,0,0,1,2.6-1.39,21.07,21.07,0,0,1,3.23-1,15.67,15.67,0,0,1,7.71.15,43.22,43.22,0,0,1,7.27,2.57c1.08.48,2.11,1,3,1.44s1.82.91,2.6,1.35c1.58.83,2.83,1.57,3.69,2.08l1,.6Q704.29,380.66,704.28,380.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.13,374.88a2.66,2.66,0,0,1,.74.21,17.85,17.85,0,0,1,1.91.83,23.14,23.14,0,0,1,9.79,9.41,15.51,15.51,0,0,1,.9,1.88,2.78,2.78,0,0,1,.25.72c-.07,0-.51-1-1.41-2.45a26.48,26.48,0,0,0-4.22-5.29,27.07,27.07,0,0,0-5.45-4C657.11,375.34,656.1,375,656.13,374.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.2,339a2.72,2.72,0,0,1,.5.15l1.41.5,2.21.82c.87.32,1.81.79,2.87,1.26a67.85,67.85,0,0,1,15.26,9.72,75.15,75.15,0,0,1,7.11,7,78.37,78.37,0,0,1,5.05,6.4c1.34,1.89,2.36,3.47,3,4.56l.8,1.26a1.81,1.81,0,0,1,.26.45,2.83,2.83,0,0,1-.33-.4c-.2-.27-.5-.68-.86-1.22-.74-1.06-1.79-2.61-3.16-4.48s-3.07-4-5.09-6.32a78.41,78.41,0,0,0-7.1-6.94A71.34,71.34,0,0,0,637.06,342c-1-.48-2-1-2.83-1.32l-2.18-.88-1.38-.57A3.6,3.6,0,0,1,630.2,339Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687,346a3.53,3.53,0,0,1-.93-.12l-1.08-.2c-.42-.08-.91-.08-1.44-.14a14.86,14.86,0,0,0-8.06,1.59,14.66,14.66,0,0,0-3.66,2.72,16.88,16.88,0,0,0-2.36,2.92,25.42,25.42,0,0,0-1.61,3.07,3.47,3.47,0,0,1,.24-.91,13,13,0,0,1,1.12-2.32,16,16,0,0,1,2.33-3,14.27,14.27,0,0,1,12-4.33c.54.08,1,.1,1.46.2l1.07.27A4.19,4.19,0,0,1,687,346Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.82,309.44a2.35,2.35,0,0,1-.44.27l-1.31.71c-1.14.62-2.78,1.52-4.76,2.69s-4.31,2.65-6.79,4.42a56.35,56.35,0,0,0-7.58,6.35,19,19,0,0,0-3.1,4c-.77,1.48-1.51,2.9-2.18,4.27a78,78,0,0,0-3.26,7.41,45.87,45.87,0,0,0-1.58,5.22c-.3,1.26-.41,2-.45,2a2.54,2.54,0,0,1,0-.52c0-.34.11-.84.24-1.47a39.92,39.92,0,0,1,1.46-5.29,73,73,0,0,1,3.19-7.48c.67-1.38,1.4-2.81,2.16-4.28a19.37,19.37,0,0,1,3.17-4.12,55.37,55.37,0,0,1,7.65-6.38c2.51-1.76,4.86-3.2,6.87-4.35s3.67-2,4.83-2.58l1.35-.64A3,3,0,0,1,698.82,309.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666,344.93a5.62,5.62,0,0,1-.23-1c-.13-.72-.31-1.63-.51-2.71A70.13,70.13,0,0,0,659.65,324l-1.15-2.5a4.51,4.51,0,0,1-.37-.95,5.44,5.44,0,0,1,.52.87c.31.58.75,1.41,1.26,2.46a61.83,61.83,0,0,1,3.48,8.43,60,60,0,0,1,2.11,8.87c.18,1.15.32,2.09.38,2.73A4.12,4.12,0,0,1,666,344.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.11,318.26a31.93,31.93,0,0,0-3.81-12.65A41.74,41.74,0,0,0,633,284.5l26.21,39.06,3.39,7C664.89,326.75,665.4,322.69,665.11,318.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.76,
    y: 395.25,
    width: 60.95,
    height: 10.8,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "646.31 403.91 651.5 437.43 691.96 437.43 698.15 403.91 646.31 403.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.67,406.07c0,.12-13.75.21-30.7.21s-30.71-.09-30.71-.21,13.75-.22,30.71-.22S702.67,406,702.67,406.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4,399.92s-5.49-37.73-5-59.69,0-46.65,0-46.65h2.53s-1.71,43.58.15,69.86,6.77,36.48,6.77,36.48H66.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75,251.13a6.66,6.66,0,0,0-2.31-3.37c-1.6-1-3.7-.6-5.49,0-7.65,2.71-14.42,17-17.51,24.45l10.15,34.18C85.9,289.43,89.07,267.15,82.75,251.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,249.14a1.67,1.67,0,0,1-.15.44l-.49,1.25c-.45,1.08-1.07,2.64-1.82,4.58-1.49,3.88-3.39,9.31-5.1,15.42s-2.86,11.75-3.58,15.85c-.36,2.05-.63,3.71-.8,4.86-.09.54-.16,1-.22,1.32a2.09,2.09,0,0,1-.1.46,1.52,1.52,0,0,1,0-.47c0-.35.08-.79.14-1.33.12-1.16.35-2.83.67-4.89a145.13,145.13,0,0,1,8.7-31.33c.78-1.93,1.45-3.48,1.94-4.53l.57-1.22A1.73,1.73,0,0,1,79.85,249.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.08,314.62c-9.51-5.26-15.12-15.14-15.64-26-.36-7.59,2-15,4.61-22.15a2.86,2.86,0,0,1,1.07-1.61,2.73,2.73,0,0,1,2.59.4c6.91,3.94,11.1,11.44,13.33,19.07A38.46,38.46,0,0,1,70.6,300a26,26,0,0,1-7.52,14.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.08,314.62a1.52,1.52,0,0,1,0-.46c0-.35,0-.78,0-1.31,0-1.14-.05-2.79-.15-4.82a130.76,130.76,0,0,0-1.76-15.79c-1.06-6.13-2.34-11.61-3.28-15.57-.47-1.94-.85-3.53-1.13-4.69-.11-.52-.21-1-.29-1.28a1.57,1.57,0,0,1-.07-.46,3.09,3.09,0,0,1,.15.44c.1.33.22.74.37,1.26.31,1.09.75,2.68,1.26,4.66,1,3.94,2.34,9.43,3.4,15.57A116.08,116.08,0,0,1,63.17,308c0,2,.06,3.69,0,4.83,0,.53,0,1-.06,1.31A2.1,2.1,0,0,1,63.08,314.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.81,372.35c9.35,2,17.06,8.66,26.09,11.86,6,2.13,12.73,2.88,17.5,7.06-1.15-2.89-3.86-4.82-6.5-6.46a115.65,115.65,0,0,0-23.65-11.29c-4.24-1.47-8.85-2.7-13.18-1.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.28,380.69c-11.73-.19-24.07-10.17-35.73-10.77,12.21-3.94,29.69-.72,35.73,10.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.85,352.57c6-2.14,12.49-2.25,18.74-1.27s12.29,3,18.29,5c-.6-4.07-3.89-7.13-7-9.83a48.85,48.85,0,0,0-7.35-5.65,16.28,16.28,0,0,0-8.81-2.48,13.88,13.88,0,0,0-9.72,4.9,16.12,16.12,0,0,0-4.17,9.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8,339.63c-7.38-6.3-18.55-5.68-28.25-5.46a229.73,229.73,0,0,1,43.81,27.3C56.76,354.61,50.12,347.59,40.8,339.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.17,330.93a82.22,82.22,0,0,1,11.35-6.59c3.88-1.76,7.51-4.57,11.26-6.61,4.86-2.63,9.07-6.29,13.54-9.55s9.36-6.22,14.83-7.08a29.14,29.14,0,0,0-13.5.78A86.7,86.7,0,0,0,93,306.82c-5.76,2.59-11.61,5.25-16.32,9.46s-8.95,8.36-8.46,14.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.68,380.69l-.37-.16-1-.53c-.88-.47-2.15-1.17-3.74-2-.79-.42-1.67-.85-2.62-1.3s-2-.93-3-1.4a45.51,45.51,0,0,0-7.22-2.51,15.42,15.42,0,0,0-7.52-.19,22.06,22.06,0,0,0-3.18.95,15.79,15.79,0,0,0-2.57,1.32,16.51,16.51,0,0,0-3.24,2.67c-.67.73-1,1.17-1,1.15a1.85,1.85,0,0,1,.21-.34c.15-.22.39-.53.71-.92a15.38,15.38,0,0,1,3.2-2.81,16.19,16.19,0,0,1,2.6-1.39,20.6,20.6,0,0,1,3.22-1,15.67,15.67,0,0,1,7.71.15A43.22,43.22,0,0,1,89,375c1.09.48,2.11,1,3,1.44s1.82.91,2.6,1.35c1.58.83,2.83,1.57,3.69,2.08l1,.6C99.58,380.59,99.69,380.67,99.68,380.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.53,374.88a2.66,2.66,0,0,1,.74.21,17.85,17.85,0,0,1,1.91.83A23.14,23.14,0,0,1,64,385.33a15.51,15.51,0,0,1,.9,1.88,2.37,2.37,0,0,1,.25.72c-.07,0-.51-1-1.41-2.45a26.48,26.48,0,0,0-4.22-5.29,27.07,27.07,0,0,0-5.45-4C52.52,375.34,51.51,375,51.53,374.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,339a2.72,2.72,0,0,1,.5.15l1.41.5,2.22.82c.86.32,1.8.79,2.86,1.26a67.85,67.85,0,0,1,15.26,9.72,75.15,75.15,0,0,1,7.11,7,76.24,76.24,0,0,1,5,6.4c1.34,1.89,2.36,3.47,3.05,4.56l.8,1.26a1.81,1.81,0,0,1,.26.45,2.5,2.5,0,0,1-.32-.4c-.21-.27-.51-.68-.87-1.22-.74-1.06-1.79-2.61-3.16-4.48s-3.07-4-5.09-6.32a78.41,78.41,0,0,0-7.1-6.94A71.09,71.09,0,0,0,32.46,342c-1-.48-2-1-2.82-1.32l-2.19-.88-1.38-.57A3.6,3.6,0,0,1,25.6,339Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.44,346a3.53,3.53,0,0,1-.93-.12l-1.08-.2c-.42-.08-.91-.08-1.44-.14a14.52,14.52,0,0,0-11.72,4.31,16.88,16.88,0,0,0-2.36,2.92,25.42,25.42,0,0,0-1.61,3.07,4.09,4.09,0,0,1,.24-.91,13.7,13.7,0,0,1,1.12-2.32,16.1,16.1,0,0,1,2.34-3,14.23,14.23,0,0,1,3.74-2.82A14.38,14.38,0,0,1,79,345.23c.53.08,1,.1,1.45.2l1.07.27A4.19,4.19,0,0,1,82.44,346Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.22,309.44a2.35,2.35,0,0,1-.44.27l-1.31.71c-1.14.62-2.77,1.52-4.76,2.69s-4.31,2.65-6.79,4.42a57,57,0,0,0-7.58,6.35,19,19,0,0,0-3.1,4q-1.15,2.22-2.18,4.27a78,78,0,0,0-3.26,7.41,45.87,45.87,0,0,0-1.58,5.22c-.3,1.26-.41,2-.45,2a2.54,2.54,0,0,1,0-.52c0-.34.11-.84.24-1.47a38.73,38.73,0,0,1,1.47-5.29A70.58,70.58,0,0,1,67.71,332c.67-1.38,1.4-2.81,2.16-4.28A19.37,19.37,0,0,1,73,323.59a55.37,55.37,0,0,1,7.65-6.38c2.51-1.76,4.87-3.2,6.87-4.35s3.67-2,4.83-2.58l1.35-.64A3,3,0,0,1,94.22,309.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.36,344.93a5,5,0,0,1-.24-1c-.13-.72-.31-1.63-.51-2.71a76.77,76.77,0,0,0-2.22-8.79A75.31,75.31,0,0,0,55.05,324l-1.15-2.5a4.51,4.51,0,0,1-.37-.95,5.44,5.44,0,0,1,.52.87c.31.58.75,1.41,1.26,2.46a60.58,60.58,0,0,1,3.48,8.43,60,60,0,0,1,2.11,8.87c.19,1.15.32,2.09.38,2.73A5.47,5.47,0,0,1,61.36,344.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.51,318.26a31.93,31.93,0,0,0-3.81-12.65A41.74,41.74,0,0,0,28.38,284.5L54.6,323.56l3.38,7C60.29,326.75,60.8,322.69,60.51,318.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.16,
    y: 395.25,
    width: 60.95,
    height: 10.8,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.71 403.91 46.9 437.43 87.36 437.43 93.55 403.91 41.71 403.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.07,406.07c0,.12-13.75.21-30.7.21s-30.71-.09-30.71-.21,13.75-.22,30.71-.22S98.07,406,98.07,406.07Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-254"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.55,438.34c0,.15-150.69.26-336.53.26s-336.57-.11-336.57-.26,150.66-.26,336.57-.26S713.55,438.2,713.55,438.34Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-254"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.44,
    y: 89.33,
    width: 137.08,
    height: 17.37,
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.84,83.32a6.76,6.76,0,0,1,10.42-4.39,11.25,11.25,0,0,1-10.16,4.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.35,84.63a4.8,4.8,0,0,1-1,5.35,12.11,12.11,0,0,1-4.95,2.93,8.78,8.78,0,0,1,5.95-8.81",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.73,76.64a7.79,7.79,0,0,1-10.2,4.73,10.61,10.61,0,0,1,4.18-4.81,5.11,5.11,0,0,1,6,.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.26,74.57a4.58,4.58,0,0,1,4.82-2.44,8,8,0,0,1,4.83,3,7,7,0,0,1-9.5-1.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.22,92.65a6.22,6.22,0,0,1,0,6.8,11,11,0,0,1-5.67,4.26,14.52,14.52,0,0,1,.79-7,7.4,7.4,0,0,1,5.19-4.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.77,69.42a5.63,5.63,0,0,0-8.56-2.54,4.87,4.87,0,0,0,8.5,2.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.85,63.55a7.31,7.31,0,0,0,10.39-3.44,16.79,16.79,0,0,0-4.3-.94,7.17,7.17,0,0,0-4.24,1,3.86,3.86,0,0,0-1.85,3.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.05,61.2a6,6,0,0,0,2.15-9,12.51,12.51,0,0,0-3.82,4.83,4.69,4.69,0,0,0-.51,2.25,2.11,2.11,0,0,0,1.23,1.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.86,72.58s0,0,0-.15,0-.25.07-.43c.07-.38.16-.94.32-1.66a15,15,0,0,1,2.35-5.67,9.29,9.29,0,0,1,3.16-2.79,6.46,6.46,0,0,1,4.69-.57,5.58,5.58,0,0,1,2.29,1.18,5,5,0,0,1,1.46,2.24,9.94,9.94,0,0,1-.18,5.68,38.61,38.61,0,0,0-1.47,5.68,8.87,8.87,0,0,0,.09,2.82,5.77,5.77,0,0,0,1.1,2.47,8.48,8.48,0,0,0,2,1.66,11.43,11.43,0,0,1,1.87,1.44,7.82,7.82,0,0,1,2.05,3.65,7.41,7.41,0,0,1,0,3.47,7.82,7.82,0,0,1-1,2.44,9.85,9.85,0,0,1-1.44,1.74l.12-.09a3.06,3.06,0,0,0,.33-.29,7.13,7.13,0,0,0,1.09-1.3,8.07,8.07,0,0,0,1.07-2.46,7.47,7.47,0,0,0,0-3.56,7.94,7.94,0,0,0-2.08-3.77c-1.08-1.16-2.73-1.77-3.79-3.1a6.87,6.87,0,0,1-1.12-5.09,40.38,40.38,0,0,1,1.47-5.63,10.16,10.16,0,0,0,.17-5.85A5.33,5.33,0,0,0,436,62.28a5.89,5.89,0,0,0-2.41-1.23,6.74,6.74,0,0,0-4.87.62,9.3,9.3,0,0,0-3.21,2.88,12.65,12.65,0,0,0-1.61,3.17,18.74,18.74,0,0,0-.68,2.6c-.14.72-.22,1.29-.27,1.67,0,.18,0,.32,0,.44S422.86,72.58,422.86,72.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.81,84a5.81,5.81,0,0,1-1-1.74,4.83,4.83,0,0,1-.2-2.31,4.74,4.74,0,0,1,1.43-2.67,4.89,4.89,0,0,1,1.49-1,5.63,5.63,0,0,1,1.9-.37c1.35-.07,2.81.24,4.37.06a4.8,4.8,0,0,0,2.27-.79,3.55,3.55,0,0,0,1.39-2.08c.45-1.66.15-3.47.81-5.08a4.69,4.69,0,0,1,1.59-2,6.05,6.05,0,0,1,2.27-1,6.32,6.32,0,0,1,4.55.79,9.61,9.61,0,0,1,3.08,3,11.3,11.3,0,0,1,1.57,3.41,40.85,40.85,0,0,1,1,5.4c.09.62.16,1.12.21,1.48,0,.16,0,.28.06.39l0,.13s0,0,0-.14,0-.23,0-.39c0-.36-.09-.86-.16-1.49a36.82,36.82,0,0,0-.92-5.44A11.39,11.39,0,0,0,412,68.72a10,10,0,0,0-3.15-3.06,7.37,7.37,0,0,0-2.24-.85,6.47,6.47,0,0,0-4.88,1.06A4.77,4.77,0,0,0,400,68c-.7,1.72-.39,3.53-.82,5.11A3.32,3.32,0,0,1,397.94,75a4.59,4.59,0,0,1-2.14.75c-1.5.18-3-.12-4.35,0a5.81,5.81,0,0,0-2,.4,4.94,4.94,0,0,0-1.55,1,4.81,4.81,0,0,0-1.45,2.78,5,5,0,0,0,.25,2.37,4.66,4.66,0,0,0,.72,1.32A3.32,3.32,0,0,0,387.81,84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.72,70a5.18,5.18,0,0,1-4.44,1.75,4.81,4.81,0,0,1-3.47-2.91A5.43,5.43,0,0,1,396,67.3a5.36,5.36,0,0,1,3.8,2.23",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,75.93a5.21,5.21,0,0,1-.81,4.7,4.81,4.81,0,0,1-4.29,1.45,5.43,5.43,0,0,1,.82-4.35,5.37,5.37,0,0,1,3.88-2.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.63,77.64A5.16,5.16,0,0,1,383,78.9a4.79,4.79,0,0,1-3.15-3.26,5.46,5.46,0,0,1,4.29-1.11,5.39,5.39,0,0,1,3.54,2.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.81,64.88a5.41,5.41,0,0,0,.43-4.85,4.8,4.8,0,0,0-3.85-2.39A5.13,5.13,0,0,0,405.52,65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.26,47.85l-.07-.11-.24-.29c-.21-.25-.53-.61-1-1a13.13,13.13,0,0,0-4.41-2.86,9.51,9.51,0,0,0-3.6-.61,8.42,8.42,0,0,0-4,1.18,6.75,6.75,0,0,0-3,3.51,21.62,21.62,0,0,0-.68,4.92,8.91,8.91,0,0,1-.57,2.38,7,7,0,0,1-1.36,2c-.55.58-1.12,1.11-1.63,1.71a8.37,8.37,0,0,0-1.22,1.93,10.36,10.36,0,0,0-.85,4.1,13.64,13.64,0,0,0,.45,3.62A28.66,28.66,0,0,0,417,73.16l.63,1.29a2.53,2.53,0,0,0,.24.43,4.18,4.18,0,0,0-.19-.46l-.57-1.31a28.68,28.68,0,0,1-1.76-4.92,13.78,13.78,0,0,1-.41-3.57,10.14,10.14,0,0,1,.86-4A7.79,7.79,0,0,1,417,58.77c.49-.58,1.07-1.11,1.62-1.7a7.14,7.14,0,0,0,1.42-2,8.74,8.74,0,0,0,.59-2.47,21.92,21.92,0,0,1,.66-4.85,6.54,6.54,0,0,1,2.85-3.38A8.23,8.23,0,0,1,428,43.18a9.17,9.17,0,0,1,3.52.57,13.2,13.2,0,0,1,4.4,2.74c.45.42.79.77,1,1A2.71,2.71,0,0,0,437.26,47.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.72,57.43c.36-.48.62-.24,1.22-.24a3.6,3.6,0,0,1,1.72.49,6.76,6.76,0,0,1,3.44,6.57,5.26,5.26,0,0,1-6.19-6.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.05,46c.11-.59.46-.49,1-.75a3.66,3.66,0,0,1,1.77-.29,6.72,6.72,0,0,1,5.92,4.45,5.27,5.27,0,0,1-8.56-3.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.82,69.14a6.07,6.07,0,0,1,9.48-1.28,7.56,7.56,0,0,1-4.52,2.82,7.7,7.7,0,0,1-5.28-1.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.77,60.66a6.14,6.14,0,0,1-7.45-6.1,5.53,5.53,0,0,1,7.64,6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.26,49.87a6.16,6.16,0,0,1-9.05-3.28,5.52,5.52,0,0,1,9.2,3.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.79,46.33a6.16,6.16,0,0,1,9,3.28,5.53,5.53,0,0,1-9.2-3.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,44.17a6.15,6.15,0,0,1-4.86-8.31,5.53,5.53,0,0,1,5.07,8.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.46,43.29a6.16,6.16,0,0,1,3.46-9,5.52,5.52,0,0,1-3.31,9.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.56,
    y: 70.21,
    width: 28.12,
    height: 4.98,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.67 74.21 409.43 89.67 426.72 89.67 429.58 74.21 405.67 74.21",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.67,75.2c0,.06-6.35.1-14.17.1s-14.16,0-14.16-.1,6.34-.09,14.16-.09S431.67,75.15,431.67,75.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.33 88.82 317.2 77.69 323.26 77.69 323.47 88.82 317.33 88.82",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.9,79.67a44.07,44.07,0,0,1-5.63,0,39.67,39.67,0,0,1,5.63,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.9,81.39a44.07,44.07,0,0,1-5.63,0,39.67,39.67,0,0,1,5.63,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.9,83.1a39.67,39.67,0,0,1-5.63,0,44.07,44.07,0,0,1,5.63,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.9,84.82a39.67,39.67,0,0,1-5.63,0,44.07,44.07,0,0,1,5.63,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.9,86.54a44.07,44.07,0,0,1-5.63,0,39.67,39.67,0,0,1,5.63,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.68,77.32h67.14a31.57,31.57,0,0,1,0,12H317v-.82h4.08A1.92,1.92,0,0,0,323,86.6V80A1.92,1.92,0,0,0,321.05,78h-4.37Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.5,89.58c-.05,0-.09-2.76-.09-6.17s0-6.17.09-6.17.1,2.76.1,6.17S381.56,89.58,381.5,89.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.56,89.58c-.05,0-.1-2.76-.1-6.17s.05-6.17.1-6.17.1,2.76.1,6.17S326.61,89.58,326.56,89.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,89.58c-.05,0-.09-2.76-.09-6.17s0-6.17.09-6.17.1,2.76.1,6.17S382.73,89.58,382.68,89.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.46,89.58s-.1-2.76-.1-6.17.05-6.17.1-6.17.09,2.76.09,6.17S325.51,89.58,325.46,89.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.06,84.73H338.21a1.63,1.63,0,0,1-1.62-1.63h0a1.63,1.63,0,0,1,1.62-1.62h34.85a1.63,1.63,0,0,1,1.63,1.62h0A1.63,1.63,0,0,1,373.06,84.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.71,67.51V76.8h8.72V67.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.61,66.71c1.36,3.29,1.16,6.92,0,10.77H328.24V76.8h3.08A4.65,4.65,0,0,0,336,72.15h0a4.65,4.65,0,0,0-4.65-4.64h-3.26v-1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.85,68.21c0,.06,9.69.1,21.63.1s21.64,0,21.64-.1-9.69-.09-21.64-.09S333.85,68.16,333.85,68.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.44,76.29c0,.06,9.73.1,21.75.1s21.75,0,21.75-.1-9.74-.09-21.75-.09S333.44,76.24,333.44,76.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.71,72.28s1.62.09,3.62.09,3.63,0,3.63-.09a65.75,65.75,0,0,0-7.25,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.71,74.37a54.83,54.83,0,0,0,6.62,0,60.91,60.91,0,0,0-6.62,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.66,76.29a29.33,29.33,0,0,0,4.84,0,32.58,32.58,0,0,0-4.84,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.64,70.4a67.71,67.71,0,0,0,7,0,61,61,0,0,0-7,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.71,68.51a17.57,17.57,0,0,0,2.7.1,17.38,17.38,0,0,0,2.69-.1,20.07,20.07,0,0,0-2.69-.09A20.28,20.28,0,0,0,328.71,68.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.87,56.7V66h18V56.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,61.43c0,.08,0,.17,0,.25a5.34,5.34,0,0,1-5.35,5H323V66h12.72a4.65,4.65,0,0,0,4.65-4.65h0a4.65,4.65,0,0,0-4.65-4.65H323v-1l53.6.18A5.36,5.36,0,0,1,382,61.43Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.87,61.47c0,.05,3.7.1,8.26.1s8.26,0,8.26-.1-3.7-.1-8.26-.1S323.87,61.42,323.87,61.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.13,63.57s3.5.09,7.81.09,7.82,0,7.82-.09-3.5-.1-7.82-.1S324.13,63.51,324.13,63.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.87,65.48s3.14.1,7,.1,7,0,7-.1-3.15-.09-7-.09S323.87,65.43,323.87,65.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.87,59.59s3.62.09,8.09.09,8.09,0,8.09-.09-3.62-.1-8.09-.1S323.87,59.53,323.87,59.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.13,57.7c0,.06,3.22.1,7.2.1s7.2,0,7.2-.1-3.22-.09-7.2-.09S324.13,57.65,324.13,57.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.78,72.84h28.81a.85.85,0,0,0,.85-.84h0a.85.85,0,0,0-.85-.85H340.78a.85.85,0,0,0-.84.85h0A.85.85,0,0,0,340.78,72.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.88,62.22h28.81a.85.85,0,0,0,.85-.85h0a.85.85,0,0,0-.85-.84H346.88a.84.84,0,0,0-.84.84h0A.84.84,0,0,0,346.88,62.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-254"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435,171.08l-2.19-7.33a25.49,25.49,0,1,0-6.11,6.8h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,171.08l-.52,0-1.58-.09-6.21-.34h-.14l.09-.11h0l.11.11a25.66,25.66,0,0,1-11.47,5,25.14,25.14,0,0,1-4,.34,28.06,28.06,0,0,1-4.22-.33,25.42,25.42,0,0,1-8.71-3A25.68,25.68,0,0,1,386.06,156a25.63,25.63,0,0,1,15.84-29.52,26,26,0,0,1,11.7-1.58,25.59,25.59,0,0,1,22.15,18.82,26.73,26.73,0,0,1,.78,4.19,31.42,31.42,0,0,1,.07,4,25.3,25.3,0,0,1-3.77,11.9v-.06c.7,2.39,1.23,4.23,1.6,5.48.17.61.3,1.08.4,1.4s.12.47.12.47l-.15-.49c-.11-.33-.25-.8-.44-1.41l-1.67-5.41v-.06a25.35,25.35,0,0,0,3.68-11.84,34.9,34.9,0,0,0-.09-3.93,27.5,27.5,0,0,0-.79-4.15,25,25,0,0,0-4-8.29,25.43,25.43,0,0,0-7.52-6.83,25.15,25.15,0,0,0-10.41-3.44A25.88,25.88,0,0,0,402,126.8a25,25,0,0,0-10,7,25.29,25.29,0,0,0,15.07,41.62,28.82,28.82,0,0,0,4.18.34,25.79,25.79,0,0,0,3.91-.32,25.52,25.52,0,0,0,11.42-4.94l.46-.36-.36.46h0l-.05-.12,6.16.43,1.59.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.84,150.41a3.15,3.15,0,1,1-3.15-3.15A3.15,3.15,0,0,1,405.84,150.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.25,150.41a3.15,3.15,0,1,1-3.15-3.15A3.15,3.15,0,0,1,415.25,150.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.67,150.41a3.15,3.15,0,1,1-3.15-3.15A3.15,3.15,0,0,1,424.67,150.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-254"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "621.38 463.14 613.35 417.65 587.21 417.65 604.74 463.22 621.38 463.14",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.56 455.17 154.61 404.14 180.75 404.14 156.2 455.24 139.56 455.17",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,275.21s26.76-10.75,54.23-5.62c5.17,1,2.12,54,2.12,54l-20.17,15.49-36.18-63.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.14,275.21s26.76-10.75,54.23-5.62c5.17,1,2.12,54,2.12,54l-20.17,15.49-36.18-63.86"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M168.6,396.45s0-42.91,0-43.74H385.77L388,396.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,273.83h19.2A14.15,14.15,0,0,1,175.32,288V398.09a1.67,1.67,0,0,1-1.67,1.67H142a14.15,14.15,0,0,1-14.15-14.15V288A14.15,14.15,0,0,1,142,273.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.43,323.58c.16-1-1.56-5.67-16.7-5.17-11.6.38-174-.77-181.92,6.39-20.14,18.19-24.05,12.61-26.21,29.34l224.81-1.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 395.95,
    width: 512.05,
    height: 21.7,
    rx: 6.46,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.06,323.58l2.73-69.34a11,11,0,0,0-11.11-11.48c-51.9-20.73-174.47-23.38-175.89-9.12L390.33,323Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603,396.45s0-42.91,0-43.74H385.78l1,43.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.33,323c-.15-.95,1.27-5.09,15.6-4.59,11,.38,162.47-1.15,170.67,5.17s23.91,12.69,26.37,30.56l-212.83-1.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.9,275.47s-25.27-11-55.42-5.88c-5.68,1-2.33,54-2.33,54l23.68,18.71,34.07-66.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M633.9,275.47s-25.27-11-55.42-5.88c-5.68,1-2.33,54-2.33,54l23.68,18.71,34.07-66.82"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M610.38,273.83h33.35a0,0,0,0,1,0,0V385.61a14.15,14.15,0,0,1-14.15,14.15h-19.2a14.15,14.15,0,0,1-14.15-14.15V288A14.15,14.15,0,0,1,610.38,273.83Z",
    transform: "translate(1239.96 673.59) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.06,396c0,.2-110.45.47-246.66.6s-246.68.09-246.68-.1,110.42-.46,246.68-.6S634.06,395.85,634.06,396Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.79,243.77a1.47,1.47,0,0,1,0,.39c0,.3,0,.68,0,1.15,0,1.07,0,2.55.07,4.44,0,3.9.06,9.45.11,16.3,0,13.8.06,32.79.1,53.77s-.07,40-.1,53.78c-.05,6.84-.08,12.4-.11,16.3,0,1.88-.05,3.37-.07,4.43,0,.47,0,.85,0,1.15a1.6,1.6,0,0,1,0,.4,2.12,2.12,0,0,1,0-.4c0-.3,0-.68,0-1.15,0-1.06,0-2.55-.06-4.43,0-3.9-.07-9.46-.12-16.3,0-13.81-.06-32.8-.1-53.78s.08-40,.1-53.77c0-6.85.09-12.4.12-16.3,0-1.89,0-3.37.06-4.44,0-.47,0-.85,0-1.15A1.93,1.93,0,0,1,391.79,243.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.49,323.58l-2.73-69.34c-.25-6.29,5.55-20.63,11.84-20.6,62.67-17.74,127-34.51,180.21-9.1,5.33,2.54,6.77,13.34,6.64,16.38V322.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.17,324.8s.75.52,2.2,1.6l6.47,4.79,10.59,7.9a19.26,19.26,0,0,1,5.55,6.36,11.06,11.06,0,0,1,.6,9.46l0,.08h-.1l-407.14-1-26.41-.09h-.31l0-.28a14.63,14.63,0,0,1,2.75-9.74A22.92,22.92,0,0,1,174.6,340c1.23-1.17,2.54-2.17,3.82-3.21l15.27-12.27.08-.07h.13c108.56-1.33,204.39-1.35,273.07-.88,34.33.22,61.89.52,80.85.76l21.8.31,5.64.1,1.91.06L467,324c-68.67-.35-164.49-.24-273.06,1.11l.21-.07-15.24,12.26c-1.28,1-2.6,2.05-3.79,3.17a23.27,23.27,0,0,0-3.19,3.74,16.83,16.83,0,0,0-2.14,4.41,11.45,11.45,0,0,0-.51,4.8l-.34-.28,26.41.08,407.14,1.44-.13.08a10.81,10.81,0,0,0-.57-9.21,19.4,19.4,0,0,0-5.46-6.3l-10.52-7.93-6.43-4.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.81,353c.19,0,.35,9.65.35,21.56s-.16,21.56-.35,21.56-.35-9.65-.35-21.56S168.62,353,168.81,353Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.47,354.14c.19,0,.35,9.36.35,20.91s-.16,20.9-.35,20.9-.35-9.36-.35-20.9S602.27,354.14,602.47,354.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,197.93c-8.81-.75-38.43-.1-38.43-.1l6.2,23.66s15.11-3.16,21.66-4.68c3.28-.75,4.35-1.26,4.53-1.54,3.83.75,21.12,2.93,31.47.29l3.78-.26,2.77-11.58S326.19,198.69,317.37,197.93Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.79,246.78c1.15,1-1.51-15.11-3.28-19.14s-13.84-20.14-15.61-21.4-7.55-2.52-7.55-2.52l-4.49,11.7s1.72,7.69,4.49,10.21,5.29,4.78,5.54,7.05,2.52,4,4,2.26.25-4.53-.76-8.05-1.76-6.55-1.76-6.55,8.56,8.56,9.32,10.57,3.27,11.59,4.78,12.34a3,3,0,0,0,2.77,0A9.72,9.72,0,0,0,375.79,246.78Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.32,206.32a15.21,15.21,0,0,1,.18,4,15.55,15.55,0,0,1-.35,3.95,15.49,15.49,0,0,1-.17-4A15.3,15.3,0,0,1,311.32,206.32Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.35,210.16a18.39,18.39,0,0,1,.33,3.32,20.23,20.23,0,0,1,.27,3.33,7.54,7.54,0,0,1-.78-3.28A7.79,7.79,0,0,1,344.35,210.16Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.09,143.83a5.61,5.61,0,0,0,4.25-10.33,5.84,5.84,0,0,0-3.3-10.59,7,7,0,0,0-9.39-7.48,7.84,7.84,0,0,0-9.49-1.88,5.59,5.59,0,0,0-6.52,8.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,118.8l1.22.21a23.83,23.83,0,0,1,19.54,25.74c-1.11,11.5-2.48,24.19-3.63,30.25-2.4,12.57-15.34,12.28-15.34,12.28l-2.13,9.91c-1.59,8.59-8.2,6.75-16.77,5.1h0c-8.29-1.59-12.93-8.94-11.67-17.29l7.19-42.78C234.6,129,241.77,117.23,255,118.8Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.89,187.28a31,31,0,0,1-15.63-7.77s2,10.1,14.79,11.21Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.75,156a1.82,1.82,0,0,1-2.05,1.5,1.75,1.75,0,0,1-1.57-1.95,1.83,1.83,0,0,1,2.06-1.51A1.75,1.75,0,0,1,270.75,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,150.43c-.26.19-1.44-1.06-3.38-1.4s-3.52.38-3.69.11.22-.51.91-.85a5,5,0,0,1,3-.37,4.76,4.76,0,0,1,2.64,1.4C272,149.88,272.08,150.34,272,150.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,154.14a1.82,1.82,0,0,1-2.06,1.5,1.74,1.74,0,0,1-1.56-1.95,1.83,1.83,0,0,1,2.06-1.5A1.73,1.73,0,0,1,254,154.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.87,147.4c-.26.2-1.45-1.05-3.38-1.39s-3.53.37-3.69.1.21-.51.91-.85a5,5,0,0,1,3-.37,4.86,4.86,0,0,1,2.64,1.4C252.87,146.86,253,147.32,252.87,147.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,163a13.47,13.47,0,0,1,3.24,0c.5,0,1,0,1.13-.3a2.52,2.52,0,0,0-.07-1.52c-.25-1.28-.51-2.62-.79-4-1.07-5.72-1.76-10.38-1.53-10.43s1.29,4.56,2.37,10.28c.25,1.41.49,2.75.72,4a2.87,2.87,0,0,1-.09,2,1.25,1.25,0,0,1-.94.58,3.35,3.35,0,0,1-.86,0A12.68,12.68,0,0,1,257.34,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.88,140.26c-.35.44-1.91-.38-3.94-.81s-3.81-.4-3.9-.94c0-.26.4-.64,1.21-.9a6.23,6.23,0,0,1,3.17-.1,5.91,5.91,0,0,1,2.8,1.44C255.82,139.52,256,140,255.88,140.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.47,142.47c-.49.36-2-.38-3.92-.74s-3.6-.34-3.89-.86c-.12-.25.21-.65,1-.94a6.34,6.34,0,0,1,3.32-.15,6.24,6.24,0,0,1,3,1.44C273.54,141.79,273.69,142.29,273.47,142.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.58,138.76s-1.92-8.47-5.39-11c-4.21-3-7.09,1.65-11.26-.36s-8.18-4.92-13.27-2.33c-5.56,2.84-3.73,5.85-5,11.38-5.26,22.43-10.54,28.1-9.81,17.22.08-1.19-3-2.7-2.6-7.72.51-6.52,1.65-14.33,3.89-18.62,1.89-3.62,4.54-5.88,9-8.1,7-3.5,15.51-2.09,21.17-.48S277.86,129,275.58,138.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,153.48a3.46,3.46,0,0,0-3.1-3.95c-2.39-.19-5.24.67-6,5.55-1.26,8.66,7.69,8.14,7.74,7.89S231.19,157.11,231.68,153.48Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,159.44s-.16.08-.44.16a1.49,1.49,0,0,1-1.13-.14c-.86-.47-1.42-2-1.24-3.6a5.1,5.1,0,0,1,.74-2.09,1.78,1.78,0,0,1,1.3-1,.77.77,0,0,1,.83.55c.08.26,0,.42,0,.44s.2-.12.19-.48a1.06,1.06,0,0,0-.27-.6,1.16,1.16,0,0,0-.8-.34,2.16,2.16,0,0,0-1.77,1.12,5.11,5.11,0,0,0-.87,2.33c-.2,1.75.46,3.52,1.65,4.06a1.63,1.63,0,0,0,1.42,0C228.92,159.65,229,159.46,229,159.44Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.82,136.83a8.3,8.3,0,0,0,3.34,2.34,2.86,2.86,0,0,0,3.47-1.42c.21-.58.19-1.31.66-1.7s1.41-.14,2.12.07c2.45.71,5.87-1.54,6.94-3.86a2.28,2.28,0,0,0,2.89,1.16,8.12,8.12,0,0,0,2.4-1.47,3.59,3.59,0,0,1,3.22-1,8.48,8.48,0,0,0,1.8.75c1.15.1,1.93-1.12,2.31-2.22s.73-2.37,1.8-2.81,2.08.12,3.09.46,2.4.33,2.85-.64a2.11,2.11,0,0,0-.11-1.63,5.67,5.67,0,0,0-6.2-3.28,7.67,7.67,0,0,0-13.62-3.94,7.8,7.8,0,0,0-12.76.62,5.64,5.64,0,0,0-7.71,7,5.34,5.34,0,0,0-3.65,3.68c-.35,1.78,1.07,3.86,2.87,3.7a3.13,3.13,0,0,0,4.78,4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.59,124.27l0,.16c0,.1-.07.25-.14.45a5.62,5.62,0,0,1-.92,1.54,6.33,6.33,0,0,1-2.27,1.7,5.9,5.9,0,0,1-3.71.38l.18-.17a3.17,3.17,0,0,1-.59,2.35,9.53,9.53,0,0,1-1.85,1.85,6.65,6.65,0,0,1-1.14.82,3,3,0,0,1-1.46.26,3.18,3.18,0,0,1-2.59-1.49l.34,0a6.61,6.61,0,0,1-3.54,4,4.84,4.84,0,0,1-3,.42,8.62,8.62,0,0,1-2.68-1.11l.25-.06a6.81,6.81,0,0,1-2.51,2.3,3.67,3.67,0,0,1-3.14.28,4.81,4.81,0,0,1-3-4.36l.18.12a4.53,4.53,0,0,1-3-.09,4.92,4.92,0,0,1-1.9-1.29,4.27,4.27,0,0,1-.77-1.22,2.22,2.22,0,0,1-.14-.48,5.34,5.34,0,0,0,1,1.6,4.72,4.72,0,0,0,1.87,1.19,4.32,4.32,0,0,0,2.87,0l.18-.06v.19a4.53,4.53,0,0,0,2.84,4.05,3.32,3.32,0,0,0,2.86-.29,6.55,6.55,0,0,0,2.36-2.18l.1-.14.15.08a8.21,8.21,0,0,0,2.56,1.06,4.44,4.44,0,0,0,2.76-.4,6.17,6.17,0,0,0,3.34-3.75l.13-.39.21.36a2.83,2.83,0,0,0,2.29,1.31A2.67,2.67,0,0,0,255,133a6.25,6.25,0,0,0,1.07-.77,8.62,8.62,0,0,0,1.8-1.76,2.86,2.86,0,0,0,.57-2.12l0-.22.21.05a5.56,5.56,0,0,0,3.54-.31,6.1,6.1,0,0,0,2.24-1.58A7,7,0,0,0,265.59,124.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.62,169.23c0-.33-2.19-.26-3.81-2.09s-1.45-4.18-1.75-4.19c-.14,0-.41.54-.41,1.53A5.47,5.47,0,0,0,252,168a4.8,4.8,0,0,0,3.19,1.62C256.1,169.64,256.64,169.38,256.62,169.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8,415.49l-19.92,19.37s13,26.76,9.67,30.7l-39-37.28,17.19-18.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.45,421.65a2.22,2.22,0,0,0-2.84.76,2.12,2.12,0,0,0,.73,2.82,2.32,2.32,0,0,0,3-.82,2.19,2.19,0,0,0-1.08-2.85",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.6,428.28l3.12-3,36.18,36.88s1,2.41-.35,3.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.7,435.27c-.19.18-1.22-.64-2.74-.92s-2.79,0-2.89-.21,1.23-1.07,3.07-.69S269.91,435.14,269.7,435.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.17,440.87c-.13.23-1.27-.24-2.68-.05s-2.42.86-2.6.67.73-1.39,2.49-1.58S272.34,440.68,272.17,440.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.81,448c-.21-.13.43-1.33,1.92-1.9s2.77-.14,2.7.09-1.16.27-2.37.76S270,448.14,269.81,448Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.75,430.35c-.25.1-.87-1-2-2s-2.31-1.41-2.25-1.67,1.51-.17,2.84,1S274,430.29,273.75,430.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,410.63l-2.78,32.88s32.49,13.87,32.57,20l-63.94-3.09,1.28-29.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.79,439.79a2.6,2.6,0,0,0-2,2.89,2.52,2.52,0,0,0,2.85,2,2.78,2.78,0,0,0,2.05-3.08c-.37-1.23-2-2.26-3.2-1.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.05,460.41l.42-5.17,61.15,4.9s2.79,1.37,2.37,3.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.48,443.24c0,.31-1.6.38-3.18,1.31s-2.47,2.2-2.75,2.06.27-1.92,2.21-3S284.56,443,284.48,443.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.05,446.34c.06.3-1.32.77-2.45,2s-1.49,2.65-1.8,2.62-.43-1.8,1-3.36S291.06,446,291.05,446.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.47,454.55c-.29.05-.64-1.53.24-3.2s2.38-2.28,2.5-2-.83,1.14-1.54,2.52S294.78,454.53,294.47,454.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.28,435.67c-.15.28-1.56-.22-3.33-.18s-3.17.52-3.32.25,1.23-1.33,3.31-1.34S284.44,435.44,284.28,435.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.42,300.91c-18.83-1.18-61.4-3.78-63.36-3.78l-35.73-3.53,11.8,34.92,49.33,9.25,18.2.05-52.54,65.64s22.1,23.85,21.89,24.81,67.09-80.33,72.25-89.66C361,321,348.25,302.08,329.42,300.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.19,299.09s38.45,10.3,45.9,18.88-9.95,122.37-9.95,122.37h-34s2.35-60,0-68.66c-1.85-6.8-2-18.21-2-22.76,0-1.23,0-2,0-2s-31.39.39-42-7.06S197.45,318,197.45,318L217,293.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,300.91a1.37,1.37,0,0,1,.38,0c.26.05.63.15,1.11.29,1,.27,2.38.71,4.19,1.33a145.41,145.41,0,0,1,15,6,54.85,54.85,0,0,1,9.68,5.59,17.16,17.16,0,0,1,2.28,2.09,9.59,9.59,0,0,1,1.65,2.75,18.45,18.45,0,0,1,1.56,6.44,62.38,62.38,0,0,1-.15,6.95c-.14,2.36-.27,4.76-.34,7.21a150.47,150.47,0,0,1-1,15.16c-2.14,20.71-4.53,39.4-6.23,52.93-.88,6.74-1.6,12.2-2.09,16-.26,1.87-.46,3.33-.61,4.35-.07.48-.12.85-.17,1.13a2.42,2.42,0,0,1-.07.39,2.26,2.26,0,0,1,0-.39l.12-1.14c.12-1,.29-2.49.5-4.36.46-3.82,1.12-9.29,1.93-16,1.61-13.55,3.94-32.24,6.09-52.94.51-5.19,1-10.2,1-15.13.07-2.45.21-4.86.35-7.22a61.66,61.66,0,0,0,.17-6.89,17.91,17.91,0,0,0-1.5-6.29,9.19,9.19,0,0,0-1.57-2.64,16.35,16.35,0,0,0-2.21-2,54.91,54.91,0,0,0-9.57-5.6,158.55,158.55,0,0,0-14.92-6.12c-1.79-.64-3.19-1.11-4.15-1.42S261.51,300.91,261.51,300.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.89,328.06a14.1,14.1,0,0,1-1.93,1.5c-1.22.89-2.88,2.13-4.66,3.56s-3.35,2.81-4.47,3.81A13.2,13.2,0,0,1,309,338.5a10.39,10.39,0,0,1,1.62-1.84,56.49,56.49,0,0,1,4.4-3.94,53.84,53.84,0,0,1,4.78-3.46A9.58,9.58,0,0,1,321.89,328.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.79,216.61c0,1,.34,20.67,0,30s-1.66,25.67-1.33,26.67S274.94,301,274.94,301s-27.15-5.34-41.15-3.67S198.45,318.62,197.45,318s-2.67-20.38,0-27.36-8.34-66.32-7.34-75.32-.87-9.48,4.13-13.82,32.36-15.35,32.36-15.35c10.88,9.45,26.5,12.55,29.1,6.23Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.76,197.57s.78,9.47,0,14.79c-.92,6.4-1.28,10.63-1.28,10.63l-17.68,2.64-16.1-33.29s6.92,0,10.95.28S290.76,197.57,290.76,197.57Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.83,207.05a2.65,2.65,0,0,1,.05.58c0,.45,0,1,.06,1.69,0,1.46.06,3.58.07,6.2,0,5.23-.07,12.46-.36,20.44s-.76,15.2-1.16,20.42c-.21,2.61-.39,4.72-.54,6.17q-.1,1-.18,1.68a2.54,2.54,0,0,1-.1.58,2.46,2.46,0,0,1,0-.59c0-.44,0-1,.09-1.68.09-1.54.22-3.63.37-6.19.31-5.22.71-12.43,1-20.41s.44-15.2.51-20.43c0-2.56.07-4.66.1-6.19,0-.69,0-1.24,0-1.69A2,2,0,0,1,275.83,207.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.66,199.43s-12.44,1.72-13.86,15.94A300.49,300.49,0,0,0,184.72,246l29.88-3.91a68.76,68.76,0,0,0,0-18.85C213.17,212.61,199.66,199.43,199.66,199.43Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6,242.13l.45,21.38,34.84-13.25L257.12,264l-43.74,26c-7.22,4.29-16.81.89-19.23-7.15a11.64,11.64,0,0,1-.34-1.45l-4.77-36Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.41,230.5a81.55,81.55,0,0,0-2.69-12.45H268.19a81.55,81.55,0,0,0-2.69,12.45c-.93,7.25-.46,15.58,6.51,19.27a12.72,12.72,0,0,0,11.86,0C290.85,246.08,291.34,237.76,290.41,230.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.66,236.11c.1,4.83,1.51,9.47,6,11.88a11.25,11.25,0,0,0,10.46,0c4.62-2.44,6-7.18,6.08-12.1Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.15,246.22a11.23,11.23,0,0,1-10.45,0c-4-2.11-5.56-5.94-5.95-10.11h-.1c.09,4.83,1.5,9.47,6.05,11.88a11.23,11.23,0,0,0,10.45,0c4.62-2.44,6-7.18,6.08-12.1h-.08C288.78,240.15,287.21,244.07,283.15,246.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.89,250.47c.28-.08,2,3.49,2.06,11,0,.64.36,10.61.07,11.48a26.59,26.59,0,0,1-2.13,2.82l3.05.37V250.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,250.56c-.38-.12-2.12,3.19-2.09,10.95,0,7.13-.2,10.66.26,11.69a26,26,0,0,0,2.13,2.76l-3.38.22V250.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.09,
    cy: 276.58,
    rx: 11.4,
    ry: 2.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.94,272.91c.14,0,0,.85-.67,1.59s-1.43,1-1.48.86.52-.55,1.09-1.21S276.8,272.86,276.94,272.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.25,275.22c-.06.13-.83-.15-1.52-.87s-.92-1.51-.79-1.56.55.55,1.17,1.2S281.32,275.09,281.25,275.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.25,236.08c0,.79-5.06,1.43-11.29,1.43s-11.3-.64-11.3-1.43,5.06-1.43,11.3-1.43S289.25,235.29,289.25,236.08Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.25,236.08c0,.79-5.06,1.43-11.29,1.43s-11.3-.64-11.3-1.43,5.06-1.43,11.3-1.43S289.25,235.29,289.25,236.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.73,218.76s-7.24,15.89,1.85,25.13c0,0-1.69-4.49-.74-13.1.55-5,3.49-10.85,3.49-10.85A23.61,23.61,0,0,1,269.73,218.76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.64,218.13s-.23.18-.68.41a16.63,16.63,0,0,1-2,.8,22.23,22.23,0,0,1-7.05,1.13,22.72,22.72,0,0,1-7-1.14,15,15,0,0,1-2-.82,2.63,2.63,0,0,1-.69-.4c0-.08,1.07.37,2.8.86a26.08,26.08,0,0,0,6.95,1,25.68,25.68,0,0,0,6.94-1C286.57,218.5,287.61,218.05,287.64,218.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.06,250.94a7.16,7.16,0,0,1-6.05,0c.05-.15,1.37.17,3,.17S281,250.79,281.06,250.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.31,251.72c.27,1.11.55,2.23.82,3.34a1,1,0,0,0,.36.66.69.69,0,0,0,.87-.26,2.33,2.33,0,0,0,.32-.94,10.91,10.91,0,0,1,1-2.76A7.06,7.06,0,0,1,276.31,251.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.25,253.2l4.64-2.94s5-4.67,7.76-6.63,19.68-2.28,19.68-2.28,11.31,1.63,11.75,3.15-.44,3.37-1.31,3.37l-11.2.11s1,1.09,4.13,1.31,4.57,0,4.68,2-.65,2-2.72,3.38c0,0,.33,3.58-5,4.67,0,0,.65,2.18-3.37,3.16s-7.51,1.84-10.12,1.74-7.05-.17-7.05-.17l-5,3Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.54,262.93a31.51,31.51,0,0,0-4.36,3.56,30.75,30.75,0,0,0-3.22,4.6,12.62,12.62,0,0,1,7.58-8.16Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.57,254.07a33.69,33.69,0,0,1,4.81.09,34.38,34.38,0,0,1,4.8.25,26.47,26.47,0,0,1-9.61-.34Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.68,258.58a26.49,26.49,0,0,1,4,.23,26,26,0,0,1,4,.29,10.7,10.7,0,0,1-4,.23A11.16,11.16,0,0,1,269.68,258.58Z",
    style: {
      fill: "#7c4236"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.72,246a1.78,1.78,0,0,1,.52-.11l1.5-.23,5.54-.72c4.67-.59,11.13-1.37,18.27-2.19l5.94-.68-.22.27c-.34-5.7-.62-10.68-.84-14.32-.08-1.73-.14-3.14-.19-4.19a9.3,9.3,0,0,1,0-1.52,10.49,10.49,0,0,1,.18,1.51c.09,1,.21,2.45.35,4.18.26,3.64.61,8.61,1,14.3l0,.24-.24,0-5.94.7c-7.14.82-13.61,1.54-18.29,2l-5.55.56-1.51.12A2.25,2.25,0,0,1,184.72,246Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.52,161.87c-.8-1.51-2.61-1.05-3.91-.41-9.82,4.85-24.22,25.19-24.45,25.54h0l8.48,11.7c3.89-1.78,9.11-7.31,13-9.1A7.23,7.23,0,0,0,467.2,188a7.33,7.33,0,0,0,1.36-3.84l3.18-20.64A2.66,2.66,0,0,0,471.52,161.87Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,186.22s-31.12,20.35-35.16,27.62a15.73,15.73,0,0,0-1.83,5.1,8,8,0,0,0,5.36,8.83L458.19,244l9.13-26.44s.66-2.2-5.84.4l-23.93-2.65,15.91-15.47Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.21,368.85,500,392.38s-19.3,21.88-17.18,26.48l46.58-25-11.5-21.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.28,382.62a2.15,2.15,0,0,1,2.48,1.47,2.08,2.08,0,0,1-1.43,2.47,2.29,2.29,0,0,1-2.62-1.57,2.15,2.15,0,0,1,1.77-2.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.36,393.83l-2.15-3.71-43.86,25.39s-1.59,2-.57,3.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.08,392.55c.13.22,1.32-.29,2.83-.16s2.62.77,2.78.57-.88-1.34-2.71-1.46S498.92,392.37,499.08,392.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.28,397.19c.06.25,1.26.11,2.55.66s2.06,1.44,2.28,1.31-.33-1.5-1.95-2.14S495.16,397,495.28,397.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.64,404.53c.24-.06-.06-1.37-1.31-2.3s-2.58-.85-2.58-.61,1,.55,2,1.33S495.41,404.63,495.64,404.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.54,386.84c.2.15,1.08-.72,2.41-1.32s2.55-.74,2.57-1-1.39-.55-2.95.18S496.33,386.72,496.54,386.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513,352.52l25.9,8.5s.06,29.18,4.7,31.21l18.27-49.62-23-8.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.39,344.88a2.17,2.17,0,0,1,2.83-.55,2.08,2.08,0,0,1,.57,2.8,2.28,2.28,0,0,1-3,.57,2.16,2.16,0,0,1-.27-3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.86,342.61l-4.07-1.35-16,48.09s.15,2.56,1.8,2.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.34,361.73c.25.08.8-1.09,2-2s2.47-1.17,2.46-1.43-1.55-.41-3,.71S538.1,361.7,538.34,361.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.58,367.73c.21.14,1-.76,2.34-1.2s2.5-.29,2.57-.53-1.23-.91-2.87-.32S538.35,367.64,538.58,367.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.72,373c.13-.2-1-1-2.51-.85s-2.5,1.07-2.34,1.25,1.13-.27,2.41-.36S543.6,373.21,543.72,373Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.65,359.14c.26,0,.34-1.25.93-2.59s1.43-2.24,1.26-2.45-1.4.51-2.08,2.09S532.42,359.19,532.65,359.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.91,276.49c-.78,0-79.61,1.7-85.87,6.13s-12.51,8.08-9.64,22.67,51.86,86.79,51.86,86.79l30.24-11.73s-26.33-53.16-31-62.81c0,0,38.31,16,51.87,16.77s27.68-6.45,32.64-14c3.28-5,9.22-14.23.71-31.44-8.27-16.73-11.2-16.41-11.2-16.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.06,356.64c.52-.79,22.15-24.37,22.15-24.37s-55.51-26.2-56.56-26.2S499,347,499,347Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.26,392.08l.55-.25,1.61-.66,6.13-2.44,21.86-8.59-.12.31L511,352.91l-15.78-33h0v0a29.43,29.43,0,0,0-5.28-9.39,30.07,30.07,0,0,0-6.1-5.58,31.18,31.18,0,0,0-4.61-2.63c-.56-.26-1-.42-1.28-.55l-.44-.21a2.48,2.48,0,0,1,.46.15c.29.11.74.26,1.31.5a28,28,0,0,1,4.7,2.54,29.87,29.87,0,0,1,6.23,5.56,29.55,29.55,0,0,1,5.41,9.48v0l15.87,32.93c4.82,10.06,9.35,19.51,13.21,27.58l.11.22-.23.09L502.64,389l-6.17,2.32-1.64.6A3.64,3.64,0,0,1,494.26,392.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.62,334.15a2.29,2.29,0,0,1-.52,0l-1.51-.08a49.83,49.83,0,0,1-5.43-1.08c-4.54-1.13-10.7-3.08-17.4-5.48S506,322.78,501.71,321c-2.17-.87-3.91-1.59-5.11-2.11l-1.38-.61a2.07,2.07,0,0,1-.46-.24,1.56,1.56,0,0,1,.5.15l1.42.51,5.16,2c4.36,1.66,10.39,3.94,17.09,6.33s12.82,4.4,17.32,5.61c2.25.62,4.09,1,5.37,1.24l1.48.18A1.63,1.63,0,0,1,543.62,334.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.24,166.5c-2.23-4.43-.65-10.29,3.26-13.34a13.2,13.2,0,0,1,14-.93,16.15,16.15,0,0,1,8,11.89A15.09,15.09,0,0,1,527,176.53c-3.05,3.24-8.09,4.66-12.2,2.94l4.59,6.85c.68,1,1.3,2.47.41,3.28s-2.22.08-3.11-.66a31,31,0,0,1-6.24-7.13c.81,1.47,1.64,3.06,1.48,4.73s-1.81,3.3-3.4,2.76c-1.22-.4-1.78-1.76-2.2-3q-1.65-4.73-3.28-9.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.5,188.21a4.56,4.56,0,0,0,1-.75,12.83,12.83,0,0,0,2.23-2.59,18,18,0,0,0,2.85-10.81,25.63,25.63,0,0,0-3.19-10.77,29.71,29.71,0,0,0-1.79-2.9,4.66,4.66,0,0,0-.78-1c-.09.06.91,1.53,2.18,4.08a27.24,27.24,0,0,1,3,10.6,18.66,18.66,0,0,1-2.59,10.55A27.07,27.07,0,0,1,503.5,188.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.6,157.59c-5.67-7.33-13.44-11.67-22.69-12.07-5.22-.23-7.41.8-11.2,1.71a16.5,16.5,0,0,0-9.57,6c-2.77,3.72-5.12,7.89-5.75,12.48a76.93,76.93,0,0,0-1.07,14.2,26,26,0,0,0,4.08,13.49l12,2.42c6.66.41,13.4.81,19.93-.54s12.94-4.66,16.57-10.25C510.94,177.22,509.27,164.92,503.6,157.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.87,157.22,477,150.39l-4.21.38c-9.46-.23-16.26,10-16.53,17.67-.3,8.51-.33,18.9.85,25.21,2.38,12.68,13.11,14,13.11,14l-.24,4.11,1.5,30.42L490.66,230l3.58-22.69L497,161.65A4.48,4.48,0,0,0,492.87,157.22Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.28,178.35A1.64,1.64,0,0,0,460.9,180a1.57,1.57,0,0,0,1.64-1.52,1.64,1.64,0,0,0-1.62-1.61A1.56,1.56,0,0,0,459.28,178.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,172.77c.2.21,1.42-.74,3.17-.78s3.07.8,3.26.58-.13-.48-.7-.87a4.38,4.38,0,0,0-2.61-.73,4.27,4.27,0,0,0-2.52.89C459.06,172.29,458.88,172.68,459,172.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.89,186.84a11.94,11.94,0,0,0-2.87-.43c-.45,0-.87-.11-1-.42a2.35,2.35,0,0,1,.26-1.34c.4-1.09.81-2.24,1.24-3.45,1.7-4.92,2.93-9,2.73-9s-1.75,3.86-3.45,8.78c-.41,1.21-.81,2.37-1.18,3.47a2.57,2.57,0,0,0-.18,1.77,1.13,1.13,0,0,0,.75.64,3.2,3.2,0,0,0,.77.08A11.08,11.08,0,0,0,469.89,186.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.16,207.65a32.37,32.37,0,0,0,16.93-5s-4.3,9-17.08,8.11Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.75,166.64c.31.43,1.65.1,3.22.19s2.89.46,3.23.07c.15-.2,0-.61-.59-1A4.86,4.86,0,0,0,463,165a4.74,4.74,0,0,0-2.62.63C459.83,166,459.62,166.44,459.75,166.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.93,178.88a1.63,1.63,0,0,1-1.59,1.63,1.56,1.56,0,0,1-1.67-1.49,1.63,1.63,0,0,1,1.59-1.63A1.56,1.56,0,0,1,477.93,178.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.76,172.74c-.21.21-1.44-.72-3.2-.73s-3.05.85-3.24.64.12-.48.68-.89a4.56,4.56,0,0,1,2.6-.77,4.32,4.32,0,0,1,2.54.85C482.68,172.26,482.86,172.64,482.76,172.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.85,167.09c-.35.39-1.7,0-3.33-.07s-3,.24-3.33-.18c-.14-.2.08-.6.69-1a5.07,5.07,0,0,1,2.72-.62,4.89,4.89,0,0,1,2.65.83C481.82,166.48,482,166.89,481.85,167.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.24,183c0-1,1-3.21,1.94-3.38,2.49-.46,7-.39,7.22,6,.3,8.68-8.48,7.19-8.5,6.94S494.32,186.24,494.24,183Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.18,189.23s.16.1.42.21a1.51,1.51,0,0,0,1.13,0c.9-.36,1.63-1.85,1.62-3.41a5.08,5.08,0,0,0-.5-2.15,1.76,1.76,0,0,0-1.18-1.13.78.78,0,0,0-.88.45c-.11.25,0,.42-.09.43s-.19-.13-.13-.5a.94.94,0,0,1,.32-.55,1.09,1.09,0,0,1,.83-.25,2.12,2.12,0,0,1,1.62,1.29A5.05,5.05,0,0,1,501,186c0,1.75-.83,3.42-2.08,3.83a1.61,1.61,0,0,1-1.39-.19C497.21,189.44,497.15,189.25,497.18,189.23Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.53,179.61l-2.26,2.22C485,172.47,467,149.18,468,150.57a27.61,27.61,0,0,1,13.62-1.11c7,1.4,20.36,5.3,19.93,13.63S496.53,179.61,496.53,179.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.18,178a2.94,2.94,0,0,0-.12-.51,9.23,9.23,0,0,0-.56-1.38A12.54,12.54,0,0,0,505,172a23.57,23.57,0,0,0-7.2-3.71c-2.87-1-6.12-1.84-9.29-3.31a42.34,42.34,0,0,1-8.43-5,43.35,43.35,0,0,1-5.9-5.45,45.26,45.26,0,0,1-3.38-4.24L470,149c-.19-.27-.3-.42-.32-.41a2.31,2.31,0,0,0,.24.46c.18.29.42.73.77,1.27a40.58,40.58,0,0,0,3.29,4.35,42.86,42.86,0,0,0,5.89,5.57,41.82,41.82,0,0,0,8.5,5.11,97.08,97.08,0,0,0,9.34,3.29,23.79,23.79,0,0,1,7.14,3.56,13.15,13.15,0,0,1,3.55,4C509,177.35,509.13,178.05,509.18,178Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.62,179.33a4.66,4.66,0,0,0-.29-1.9,8.82,8.82,0,0,0-3.14-4.17,19.81,19.81,0,0,0-7.16-3,43.06,43.06,0,0,1-8.91-3.1,38,38,0,0,1-7.88-5.16,38.8,38.8,0,0,1-5.34-5.55,40,40,0,0,1-2.95-4.29l-.7-1.23c-.17-.28-.26-.43-.28-.42a2.92,2.92,0,0,0,.2.46c.16.33.37.76.63,1.27a33.92,33.92,0,0,0,2.85,4.4,37.28,37.28,0,0,0,13.28,10.92,42.05,42.05,0,0,0,9,3.1,19.94,19.94,0,0,1,7.07,2.88,9,9,0,0,1,3.17,4A10.74,10.74,0,0,1,506.62,179.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.59,188.86a1.34,1.34,0,0,1,.76-.26,1.16,1.16,0,0,1,.65.35,3,3,0,0,1-2.06,5.13c-1.19,0-2.59-.68-3.3-2.82C472.88,190.54,474.35,189.57,475.59,188.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.94,194.16a4.37,4.37,0,0,0,1.71-.74,2.79,2.79,0,0,0,1-1.65,3,3,0,0,0-.53-2.28c-.26-.32-.59-.64-.89-.59a3.52,3.52,0,0,0-1,.51l-1.82,1.05a9,9,0,0,1-1.74.88,9.28,9.28,0,0,1,1.58-1.14l1.78-1.13a3.52,3.52,0,0,1,1.18-.59,1,1,0,0,1,.76.23,2.56,2.56,0,0,1,.52.52,3.24,3.24,0,0,1,.58,2.61,3,3,0,0,1-1.21,1.82A2.29,2.29,0,0,1,474.94,194.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.17,243.67c.63,0,23.45-2,23.45-2s-23-17.52-25.32-22.8-9.49-12.08-5.48-16.94,17.72-5.59,26.8,2,33.11,32.56,35.64,35.3,11.07,11.37,8.33,20.24-8.92,6.8-17.57,7.06-46.25-4.82-46.67-5.46S506.17,243.67,506.17,243.67Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.44,216.36h5.84l12.6,9,8.86-21.73,6.58-3.76,41.07,30.49,5.07,16.43s21.38,19.45,22.11,25.83-15.07,7.05-31.39,4.56l-46.16,1,.19-4.59c-3.31-2.74-16.08-8.1-20.07-12.59a142.08,142.08,0,0,1-15-19.55Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482,224.63a73.05,73.05,0,0,0-2.41-11.18H462a73.05,73.05,0,0,0-2.41,11.18c-.84,6.51-.42,14,5.84,17.31a11.44,11.44,0,0,0,10.64,0C482.38,238.62,482.81,231.15,482,224.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.66,229.66c.08,4.35,1.35,8.51,5.43,10.67a10.06,10.06,0,0,0,9.39,0c4.14-2.19,5.4-6.45,5.46-10.86Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.46,238.74a10.06,10.06,0,0,1-9.39,0c-3.57-1.89-5-5.33-5.34-9.08h-.09c.09,4.35,1.36,8.51,5.43,10.67a10.06,10.06,0,0,0,9.39,0c4.15-2.19,5.4-6.45,5.46-10.86h-.08C480.52,233.29,479.11,236.82,475.46,238.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,242.56c.25-.07,1.77,3.14,1.85,9.91,0,.58.32,9.53.06,10.31a22.83,22.83,0,0,1-1.91,2.53l2.74.34V242.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.55,242.64c-.34-.11-1.91,2.86-1.88,9.83,0,6.41-.18,9.58.23,10.5a24.54,24.54,0,0,0,1.91,2.48l-3,.2V242.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.15,266c0,1.32-4.58,2.38-10.24,2.38s-10.23-1.06-10.23-2.38,4.58-2.38,10.23-2.38S481.15,264.69,481.15,266Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.89,262.71c.13,0,0,.78-.58,1.44s-1.3.89-1.36.76.46-.52,1-1.1S469.75,262.66,469.89,262.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.76,264.79c-.06.12-.77-.12-1.39-.77s-.82-1.37-.69-1.42.51.49,1.07,1.06S473.83,264.66,473.76,264.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.94,229.64c0,.71-4.54,1.28-10.14,1.28s-10.14-.57-10.14-1.28,4.54-1.29,10.14-1.29S480.94,228.93,480.94,229.64Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.94,229.64c0,.71-4.54,1.28-10.14,1.28s-10.14-.57-10.14-1.28,4.54-1.29,10.14-1.29S480.94,228.93,480.94,229.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.41,214.09s-6.5,14.26,1.66,22.56c0,0-1.52-4-.67-11.76a34.71,34.71,0,0,1,3.14-9.74A20.78,20.78,0,0,1,463.41,214.09Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.5,213.53a8.61,8.61,0,0,1-2.42,1.1,20,20,0,0,1-12.67,0A8.77,8.77,0,0,1,462,213.5a29,29,0,0,0,8.75,1.63A29.57,29.57,0,0,0,479.5,213.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.58,243a6.08,6.08,0,0,1-5.43,0c.05-.14,1.24.13,2.72.14A26.85,26.85,0,0,1,473.58,243Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.32,243.68c.24,1,.49,2,.73,3a.92.92,0,0,0,.33.6.63.63,0,0,0,.78-.24,2.05,2.05,0,0,0,.29-.84,10,10,0,0,1,.91-2.48A6.38,6.38,0,0,1,469.32,243.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M467.91,231.16s10-1.13,11.72-.69S484,234,484,234l11.72,7.94,10.43,1.77L505.35,261l-11.44-3s-6.59-1.71-9-3.42-16.36-.85-16.36-.85-5-.61-4.84-2.93c0,0-1,.63-1.63-1.1l0-.06a2.62,2.62,0,0,1,2.23-3.42l14.27-1.52s-17.21.24-17.7-1-.37-3,2.08-3.3,17.82-1.58,17.82-1.58-2.44-3.54-4-3.79-8.18,1.22-9-.24S467.91,231.16,467.91,231.16Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,222.82a3.4,3.4,0,0,1,.45.31l1.21,1,4.41,3.56c3.71,3,8.82,7.24,14.43,11.92l2.25,1.87.49.4-.63,0L513,243.25l-5,.35-1.35.07a2.79,2.79,0,0,1-.47,0,1.5,1.5,0,0,1,.46-.09l1.34-.17,5-.51,16.67-1.53-.14.46L527.21,240l-14.33-12-4.31-3.7-1.15-1C507.16,223,507,222.84,507,222.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.05,264.38a4.26,4.26,0,0,1-.62.17l-1.79.41c-.78.19-1.75.34-2.87.52s-2.4.36-3.82.52a120.46,120.46,0,0,1-22.32.13c-8.71-.65-16.52-1.85-22.16-2.76-2.82-.47-5.09-.87-6.66-1.17l-1.81-.35a3,3,0,0,1-.62-.16,2.81,2.81,0,0,1,.64.05l1.82.26,6.69,1c5.65.82,13.46,2,22.14,2.61a130,130,0,0,0,22.24,0c1.42-.13,2.7-.26,3.82-.44s2.09-.27,2.87-.43l1.81-.31A2.39,2.39,0,0,1,567.05,264.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,233.7c.08,0,.56,1.35,1.48,3.53a62.71,62.71,0,0,0,4.18,8.21,65.71,65.71,0,0,0,5.36,7.49c1.51,1.81,2.52,2.87,2.46,2.93a3.76,3.76,0,0,1-.78-.67c-.49-.45-1.16-1.14-2-2a51.77,51.77,0,0,1-5.52-7.46,50.79,50.79,0,0,1-4.08-8.34c-.42-1.11-.73-2-.91-2.67A4.26,4.26,0,0,1,454,233.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07,270.71a7.94,7.94,0,0,1-1.44,0c-.92-.05-2.26-.11-3.91-.16a125.71,125.71,0,0,0-12.89.25A127.38,127.38,0,0,0,502,272.39c-1.63.29-2.94.54-3.85.73a7.61,7.61,0,0,1-1.42.22,8.31,8.31,0,0,1,1.38-.42c.89-.25,2.19-.55,3.82-.89a99.73,99.73,0,0,1,12.82-1.77,101.35,101.35,0,0,1,13-.1c1.65.1,3,.22,3.91.33A7.41,7.41,0,0,1,533.07,270.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.4,249.28a124,124,0,0,1-15.85,1.65,123.52,123.52,0,0,1,15.85-1.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.07,241.51c0,.08-1-.25-2.65-.61a28,28,0,0,0-12.92.19,26.76,26.76,0,0,1-2.63.69,9.51,9.51,0,0,1,2.53-1,23.81,23.81,0,0,1,13.11-.2A9.82,9.82,0,0,1,547.07,241.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.17,199.87a6.62,6.62,0,0,1-.95,1.08l-2.73,2.81c-2.32,2.36-5.54,5.6-9.17,9.11-1.81,1.76-3.56,3.41-5.19,4.88-.82.73-1.59,1.42-2.38,2s-1.57,1-2.26,1.51l-3.29,2.12a8.06,8.06,0,0,1-1.25.72,7.8,7.8,0,0,1,1.13-.89l3.2-2.25c.67-.48,1.45-1,2.21-1.56s1.51-1.29,2.32-2c1.6-1.48,3.34-3.15,5.15-4.9l9.27-9c1.19-1.15,2.16-2.07,2.85-2.7A8,8,0,0,1,453.17,199.87Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkingWinePana);
export default __webpack_public_path__ + "static/media/drinking-wine-pana.75994687f006bfb32009414dec641717.svg";
export { ForwardRef as ReactComponent };